import { getMemberFriendById, getMemberPhoto, getMemberTicketRedemptionCardById } from '@vista/omnichannel-components-domain';
import { TicketRedemptionCardType } from '@vista-digital/ocapi-types/v1';
/**
 * Returns props required to render a member photo for a [[MemberTicketRedemptionCard]]
 * or `undefined` if a photo should not be shown for the card.
 *
 * @param cardId The unique identifier of the card
 * @returns Props used to render a member photo for the card, or `undefined`.
 */
export const getMemberPhotoPropsForTicketRedemptionCard = (cardId, memberSubscriptionsConfig) => {
    var _a;
    const { showMemberSubscriptionCardMemberPhotos } = memberSubscriptionsConfig;
    if (!cardId || !showMemberSubscriptionCardMemberPhotos)
        return undefined;
    const card = getMemberTicketRedemptionCardById(cardId);
    if (!card || card.type !== TicketRedemptionCardType.MemberSubscriptionCard)
        return undefined;
    return {
        photo: card.friendId ? (_a = getMemberFriendById(card.friendId)) === null || _a === void 0 ? void 0 : _a.photo : getMemberPhoto(),
        name: card.memberName
    };
};
